// Local
import { ILoggedInUser } from "../../models";
import { PAUSE_AFTER_ALERT_ACTION_APPLIED, storePauseAfterAlertAction } from "../../state/alert/alert.states";
import { LYTEHOUSE_ORG_ID, WATCHTOWER_ORG_ID, WATCHTOWER_ORG_IDS } from "./organisations";


export function getDefaultPauseAfterActionValue(user: ILoggedInUser): string {
  if (user.organisation_id === WATCHTOWER_ORG_ID) {
      const appliedKey: string = `${user.id.slice(0, 6)}_${PAUSE_AFTER_ALERT_ACTION_APPLIED}`
      if (localStorage.getItem(appliedKey) == null) {
        storePauseAfterAlertAction(user, true)
        localStorage.setItem(appliedKey, "")
      }
      return "true"
  }
  return "false"
}

const DEFAULT_LOCK_POLLING_TIME: number = 2000;
const DEFAULT_LOCK_ACQUIRE_TIME: number = 1500;

export function shouldUseTweakedLocks(user: ILoggedInUser): boolean {
  if (user.organisation_id === LYTEHOUSE_ORG_ID || WATCHTOWER_ORG_IDS.includes(user.organisation_id)) {
    return true;
  }
  return false;
}

export function getDefaultLockPollingTime(user: ILoggedInUser): number {
  if (shouldUseTweakedLocks(user)) {
    return 1000;
  }
  return DEFAULT_LOCK_POLLING_TIME;
}

export function getDefaultLockAcquireTime(user: ILoggedInUser): number {
  if (shouldUseTweakedLocks(user)) {
    return 1250;
  }
  return DEFAULT_LOCK_ACQUIRE_TIME;
}
